export const types = <const>{
	mutations: {
		ZAKAZKA_FILTER_ZAKAZNIK_SELECT_MAPPER: 'ZAKAZKA_FILTER_ZAKAZNIK_SELECT_MAPPER',
		ZAKAZKA_FILTER_OZAKAZKA_SELECT_MAPPER: 'ZAKAZKA_FILTER_OZAKAZKA_SELECT_MAPPER',
		ZAKAZKA_FILTER_POJISTOVNA_SELECT_MAPPER: 'ZAKAZKA_FILTER_POJISTOVNA_SELECT_MAPPER',
		ZAKAZKA_FILTER_LEAZING_ZAKAZNIK_SELECT_MAPPER: 'ZAKAZKA_FILTER_LEAZING_ZAKAZNIK_SELECT_MAPPER',
		ZAKAZKA_FILTER_SMLUNI_PARTNER_SELECT_MAPPER: 'ZAKAZKA_FILTER_SMLUNI_PARTNER_SELECT_MAPPER',
		ZAKAZKA_FILTER_ZADAVATEL_SELECT_MAPPER: 'ZAKAZKA_FILTER_ZADAVATEL_SELECT_MAPPER',
	},
};
